import { Component, Input, OnInit } from '@angular/core';
import { ApplicantForm } from '../../forms/applicant.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';
import { EntityType } from '../../../../../../../pipes/entity-type.pipe';

@Component({
  selector: 'app-applicant-nip-data-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent
  ],
  templateUrl: './applicant-nip-data-form.component.html'
})
export class ApplicantNipDataFormComponent implements OnInit {
  @Input()
  public form: ApplicantForm | undefined;

  public ngOnInit(): void {
    this.form?.nip?.enable();
    this.form?.firstName.enable();
    this.form?.lastName.enable();

    this.form?.pesel?.disable();
    this.form?.fatherName.disable();
    this.form?.motherName.disable();
    this.form?.birthDate.disable();

    if (this.form?.entityType.value === EntityType.OSOBA_PRAWNA) {
      this.form?.regon.disable();
      this.form?.firstName.disable();
      this.form?.lastName.disable();

      this.form?.name.enable();
    } else {
      this.form?.regon.enable();
      this.form?.regon?.setValidators([]);
    }
  }
}
